import {
  CLOSE_SIDEBAR,
  OPEN_SIDEBAR,
  MARGIN_LEFT_CLASS_NAME_SIDEBAR_OPEN,
  MARGIN_LEFT_CLASS_NAME_SIDEBAR_CLOSED,
  REPLACE_SIDEBAR,
  REMOVE_SIDEBAR,
  SET_LOTTIE_FUNCTION,
} from "./constants"

// normal action creators
export const closeSidebar = () => ({
  className: MARGIN_LEFT_CLASS_NAME_SIDEBAR_CLOSED,
  type: CLOSE_SIDEBAR,
})

// normal action creators
export const openSidebar = () => ({
  className: MARGIN_LEFT_CLASS_NAME_SIDEBAR_OPEN,
  type: OPEN_SIDEBAR,
})

export const replaceSidebar = ({ sidebar, name }) => ({
  sidebar,
  name,
  type: REPLACE_SIDEBAR,
})

export const removeSidebar = () => ({
  type: REMOVE_SIDEBAR,
})

export const setLottieFunctions = ({
  lottieStopFunction,
  lottiePlayFunction,
  module,
  lottieRef,
}) => ({
  type: SET_LOTTIE_FUNCTION,
  lottieStopFunction,
  lottiePlayFunction,
  module,
  lottieRef,
})
